
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"20","height":"15","x":"2","y":"5","stroke":"#000","rx":"1.96"}}),_c('path',{attrs:{"stroke":"#000","d":"M22 7l-8.681 6.077a2.301 2.301 0 01-2.638 0L2 7h0v-.04A1.96 1.96 0 013.96 5h16.08A1.96 1.96 0 0122 6.96V7h0z"}}),_c('rect',{attrs:{"width":"4","height":"1.38","x":"16","y":"15.61","fill":"#00DCF7","fill-rule":"nonzero","rx":".34"}})])])
          )
        }
      }
    